<template>
  <div class="modal fade" id="modal_nfse_confirmation" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Confirmar Geração de NFSe</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fechar"></button>
        </div>
        <form @submit.prevent="confirm">
          <div class="modal-body">
            <div class="alert alert-info">
              <i class="bi bi-info-circle me-2"></i>
              Revise os dados da NFSe que será gerada antes de confirmar.
            </div>

            <div v-if="nfsePreview" class="mb-4">
              <h6 class="fw-bold mb-3">Dados da NFSe</h6>
              
              <div class="row mb-3">
                <div class="col-md-6">
                  <label class="form-label">Tomador:</label>
                  <input 
                    type="text"
                    class="form-control"
                    v-model="nfsePreview.nfse_taker_name"
                    disabled>
                </div>
                <div class="col-md-6">
                  <label class="form-label">CPF/CNPJ:</label>
                  <input 
                    type="text" 
                    class="form-control" 
                    v-model="nfsePreview.nfse_taker_document"
                    :v-mask="documentMask"
                    disabled>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-6">
                  <label class="form-label">E-mail:</label>
                  <input 
                    type="email" 
                    class="form-control" 
                    v-model="nfsePreview.nfse_taker_email"
                    :placeholder="nfsePreview.nfse_taker_email || '-'"
                    disabled>
                </div>
                <div class="col-md-6">
                  <label class="form-label">Telefone:</label>
                  <input 
                    type="text" 
                    class="form-control" 
                    v-model="nfsePreview.nfse_taker_phone"
                    v-mask="['(##) ####-####', '(##) #####-####']"
                    :placeholder="nfsePreview.nfse_taker_phone || '-'"
                    disabled>
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Data de Competência:</strong>
                  <p class="mb-0">{{ formatDate(nfsePreview.nfse_competence_date) }}</p>
                </div>
                <div class="col-md-6">
                  <strong>Valor do Serviço:</strong>
                  <p class="mb-0 fw-bold text-primary">{{ formatCurrency(nfsePreview.nfse_service_value) }}</p>
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Código do Serviço (Nacional):</strong>
                  <p class="mb-0">{{ nfsePreview.nfse_service_code_national || '-' }}</p>
                </div>
                <div class="col-md-6">
                  <strong>Código do Serviço (Municipal):</strong>
                  <p class="mb-0">{{ nfsePreview.nfse_service_code_municipal || '-' }}</p>
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label required">Descrição do Serviço:</label>
                <textarea 
                  class="form-control" 
                  v-model="nfsePreview.nfse_service_description" 
                  rows="3"
                  required
                  placeholder="Descreva o serviço prestado"></textarea>
              </div>

              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Alíquota ISS:</strong>
                  <p class="mb-0">{{ nfsePreview.nfse_iss_aliquot ? (nfsePreview.nfse_iss_aliquot + '%') : '-' }}</p>
                </div>
                <div class="col-md-6">
                  <strong>ISS Retido:</strong>
                  <p class="mb-0">{{ nfsePreview.nfse_iss_retained ? 'Sim' : 'Não' }}</p>
                </div>
              </div>

              <div v-if="nfsePreview.nfse_taker_address" class="mb-3">
                <label class="form-label">Endereço:</label>
                <div class="row">
                  <div class="col-md-8 mb-2">
                    <input 
                      type="text" 
                      class="form-control" 
                      v-model="nfsePreview.nfse_taker_address"
                      readonly>
                  </div>
                  <div class="col-md-2 mb-2">
                    <input 
                      type="text" 
                      class="form-control" 
                      v-model="nfsePreview.nfse_taker_number"
                      placeholder="Nº"
                      readonly>
                  </div>
                  <div class="col-md-2 mb-2">
                    <input 
                      type="text" 
                      class="form-control" 
                      v-model="nfsePreview.nfse_taker_zipcode"
                      v-mask="'#####-###'"
                      placeholder="CEP"
                      readonly>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <input 
                      type="text" 
                      class="form-control" 
                      v-model="nfsePreview.nfse_taker_complement"
                      placeholder="Complemento"
                      readonly>
                  </div>
                  <div class="col-md-6 mb-2">
                    <input 
                      type="text" 
                      class="form-control" 
                      v-model="nfsePreview.nfse_taker_neighborhood"
                      placeholder="Bairro"
                      readonly>
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="text-center py-4">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Carregando...</span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancelar</button>
            <div v-if="generatedNfse && canDownloadDanfse" class="btn-group">
              <button type="button" class="btn btn-success dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="bi bi-file-earmark-pdf me-2"></i>
                DANFSE
              </button>
              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item" href="#" @click.prevent="openDanfse">
                    <i class="bi bi-eye me-2"></i>
                    Abrir em nova aba
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#" @click.prevent="downloadDanfse">
                    <i class="bi bi-download me-2"></i>
                    Baixar PDF
                  </a>
                </li>
                <li><hr class="dropdown-divider"></li>
                <li>
                  <a class="dropdown-item" href="#" @click.prevent="showEmailModal">
                    <i class="bi bi-envelope me-2"></i>
                    Enviar por e-mail
                  </a>
                </li>
              </ul>
            </div>
            <div v-else-if="generatedNfse" class="alert alert-info mb-0">
              <i class="bi bi-info-circle me-2"></i>
              NFSe criada! Emita a NFSe para gerar a DANFSE.
            </div>
            <button v-else type="submit" class="btn btn-success" :disabled="generating || !nfsePreview">
              {{ generating ? 'Gerando...' : 'Confirmar e Emitir NFSe' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../helpers/http";
import Alert from "../../helpers/alert";
import Loader from "../../helpers/loader";
import Modal from "../../helpers/modal";
import Download from "../../helpers/download";
import {mask} from "vue-the-mask";
import moment from "moment";

export default {
  name: "ModalNfseConfirmation",
  emits: ['confirmed', 'cancelled'],
  directives: {
    mask
  },
  data() {
    return {
      modal: null,
      schedule: null,
      nfsePreview: null,
      generating: false,
      generatedNfse: null,
      showEmailInput: false,
      emailToSend: '',
    };
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    documentMask() {
      if (!this.nfsePreview?.nfse_taker_document) return '';
      const cleaned = this.nfsePreview.nfse_taker_document.replace(/\D/g, '');
      if (cleaned.length === 11) {
        return '###.###.###-##';
      } else if (cleaned.length === 14) {
        return '##.###.###/####-##';
      }
      return '';
    },
    canDownloadDanfse() {
      if (!this.generatedNfse) return false;
      return this.generatedNfse.nfse_status === 'AUTHORIZED' || 
             this.generatedNfse.nfse_status === 'CORRECTED' ||
             this.generatedNfse.nfse_access_key;
    },
  },
  mounted() {
    this.modal = new bootstrap.Modal(document.getElementById('modal_nfse_confirmation'));
    
    Modal.onAfterClose('#modal_nfse_confirmation', () => {
      this.$emit('cancelled');
    });
  },
  methods: {
    async open(schedule) {
      this.schedule = schedule;
      this.nfsePreview = null;
      this.generating = false;
      this.generatedNfse = null;
      this.showEmailInput = false;
      this.emailToSend = '';
      
      this.modal.show();
      await this.loadPreview();
    },
    async loadPreview() {
      try {
        const response = await http.get(`/places/${this.place.id_place}/schedules/${this.schedule.id_sched}`);
        const scheduleData = response.data;
        
        const settingsResponse = await http.get(`/places/${this.place.id_place}/nfse/settings`);
        const settings = settingsResponse.data;
        
        const patient = scheduleData.patient || scheduleData.patientUser || this.schedule?.patient || {};
        
        this.nfsePreview = {
          nfse_taker_name: patient.patient_name || '',
          nfse_taker_document: patient.patient_cpf || '',
          nfse_taker_email: patient.patient_email || null,
          nfse_taker_phone: patient.patient_phone || null,
          nfse_taker_address: patient.patient_address || null,
          nfse_taker_number: patient.patient_addr_number || null,
          nfse_taker_complement: patient.patient_addr_compl || null,
          nfse_taker_neighborhood: patient.patient_neighborhood || null,
          nfse_taker_zipcode: patient.patient_zip_code || null,
          nfse_competence_date: scheduleData.sched_date || this.schedule?.sched_date || '',
          nfse_service_value: parseFloat(scheduleData.sched_value || this.schedule?.sched_value || 0),
          nfse_service_code_national: settings?.nfse_tax_code_national || '',
          nfse_service_code_municipal: settings?.nfse_tax_code_municipal || '',
          nfse_service_description: this.buildServiceDescription(scheduleData)
              || settings?.nfse_service_description || '',
          nfse_iss_aliquot: settings?.nfse_iss_aliquot || null,
          nfse_iss_retained: settings?.nfse_iss_retained || false,
        };
      } catch (e) {
        console.error('Erro ao carregar preview:', e);
        Alert.toastError('Erro ao carregar dados da NFSe.');
        this.modal.hide();
      }
    },
    /// Descrição pronta da nota gerada a partir da consulta — mesmo texto que
    /// a API monta quando o campo vai vazio.
    buildServiceDescription(scheduleData) {
      const specialty = scheduleData?.specialty || {};
      const kind = specialty.kind || {};
      const isExam = !!kind.kind_exam;
      const isMedical = (kind.kind_acronym || '').toUpperCase() === 'CRM';
      const isReturn = (scheduleData?.sched_type || '') === 'RT';

      let service;
      if (isExam) {
        service = 'Exame';
      } else if (isReturn) {
        service = isMedical ? 'Consulta médica de retorno' : 'Consulta de retorno';
      } else {
        service = isMedical ? 'Consulta médica' : 'Consulta';
      }

      const parts = [service];

      if (specialty.spec_name) {
        parts.push(`${isExam ? 'de' : 'em'} ${specialty.spec_name}`);
      }

      const date = scheduleData?.sched_date;
      if (date) {
        parts.push(`${isExam ? 'realizado' : 'realizada'} em ${moment(date).format('DD/MM/YYYY')}`);
      }

      return parts.join(' ');
    },
    async confirm() {
      if (!this.schedule || !this.nfsePreview) return;
      
      if (!this.nfsePreview.nfse_service_description || this.nfsePreview.nfse_service_description.trim() === '') {
        Alert.toastError('A descrição do serviço é obrigatória.');
        return;
      }
      
      this.generating = true;
      Loader.show('Gerando NFSe', 'Aguarde...');
      
      try {
        const payload = {
          nfse_service_description: this.nfsePreview.nfse_service_description,
        };
        
        const response = await http.post(
          `/places/${this.place.id_place}/nfse/from-schedule/${this.schedule.id_sched}`,
          payload
        );

        Alert.toastSuccess('NFSe criada com sucesso!');
        this.generatedNfse = response.data;
        // Não fechar o modal, mostrar botão dropdown
      } catch (e) {
        console.log(e)
        Alert.toastError(e.response?.data?.message);
      } finally {
        this.generating = false;
        Loader.close();
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '-';
      return new Date(dateStr).toLocaleDateString('pt-BR');
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(value || 0);
    },
    async openDanfse() {
      if (!this.generatedNfse) return;
      
      Loader.show('Gerando DANFSE', 'Aguarde...');
      try {
        const response = await http.get(
          `/places/${this.place.id_place}/nfse/${this.generatedNfse.id_nfse}/danfse`,
          { responseType: 'blob' }
        );
        
        Download.openPdf(response.data);
      } catch (e) {
        Alert.toastError('Erro ao abrir DANFSE.');
      } finally {
        Loader.close();
      }
    },
    async downloadDanfse() {
      if (!this.generatedNfse) return;
      
      Loader.show('Gerando DANFSE', 'Aguarde...');
      try {
        const response = await http.get(
          `/places/${this.place.id_place}/nfse/${this.generatedNfse.id_nfse}/danfse`,
          { responseType: 'blob' }
        );
        
        Download.downloadFile(
          response.data,
          `danfse_${this.generatedNfse.nfse_number || this.generatedNfse.id_nfse}.pdf`,
          'application/pdf'
        );
      } catch (e) {
        Alert.toastError('Erro ao baixar DANFSE.');
      } finally {
        Loader.close();
      }
    },
    showEmailModal() {
      this.emailToSend = this.nfsePreview?.nfse_taker_email || '';
      this.showEmailInput = true;
      
      this.$nextTick(() => {
        Swal.fire({
          title: 'Enviar DANFSE por e-mail',
          html: `
            <div class="mb-3">
              <label for="swal-email" class="form-label">E-mail:</label>
              <input type="email" id="swal-email" class="form-control" value="${this.emailToSend}" placeholder="email@exemplo.com">
            </div>
          `,
          showCancelButton: true,
          confirmButtonText: 'Enviar',
          cancelButtonText: 'Cancelar',
          confirmButtonColor: '#780f5a',
          preConfirm: () => {
            const email = document.getElementById('swal-email').value;
            if (!email) {
              Swal.showValidationMessage('E-mail é obrigatório');
              return false;
            }
            return email;
          }
        }).then((result) => {
          if (result.isConfirmed) {
            this.sendDanfseByEmail(result.value);
          }
          this.showEmailInput = false;
        });
      });
    },
    async sendDanfseByEmail(email) {
      if (!this.generatedNfse) return;
      
      this.sendingEmail = true;
      Loader.show('Enviando e-mail', 'Aguarde...');
      
      try {
        await http.post(
          `/places/${this.place.id_place}/nfse/${this.generatedNfse.id_nfse}/danfse/send-email`,
          { email }
        );
        
        Alert.toastSuccess('DANFSE enviada por e-mail com sucesso!');
      } catch (e) {
        Alert.toastError(e.response?.data?.message || 'Erro ao enviar e-mail.');
      } finally {
        this.sendingEmail = false;
        Loader.close();
      }
    },
  },
};
</script>

